// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1ZSbS","label":"Section_label__yZ2_c","contentWrap":"Section_contentWrap__3nq-o","footer":"Section_footer__3DH_w","footerInner":"Section_footerInner__b7hgZ"};